/**
 * App backdrop (page gutter) themes.
 * Picker shows a curated short list; legacy ids still apply if already saved.
 */

/** Themes offered in Preferences */
export const SHELL_THEMES = [
  { id: 'mist', label: 'Soft mist' },
  { id: 'teal', label: 'Clinical teal' },
  { id: 'navy', label: 'Navy' },
  { id: 'sage', label: 'Sage' },
  { id: 'graphite', label: 'Graphite' },
  { id: 'frost', label: 'Soft frost' },
  { id: 'slate', label: 'Slate blue' },
  { id: 'cloud', label: 'Soft cloud' },
];

/** Full set still valid for stored prefs / CSS apply */
export const ALL_SHELL_THEME_IDS = [
  'original', 'slate', 'indigo', 'teal', 'navy', 'steel', 'mist', 'sage',
  'plum', 'ocean', 'sky', 'lavender', 'graphite', 'rose', 'forest', 'copper',
  'midnight', 'purple', 'amber', 'wine', 'olive', 'cyan', 'coral',
  'frost', 'cloud', 'mint', 'blush', 'sand', 'lilac',
];

const SHELL_THEME_LABELS = {
  ...Object.fromEntries(SHELL_THEMES.map((t) => [t.id, t.label])),
  slate: 'Slate blue',
  indigo: 'Deep indigo',
  steel: 'Steel gray',
  plum: 'Plum',
  ocean: 'Ocean',
  sky: 'Sky',
  lavender: 'Lavender',
  rose: 'Rose',
  forest: 'Forest',
  copper: 'Copper',
  midnight: 'Midnight',
  purple: 'Purple',
  amber: 'Amber',
  wine: 'Wine',
  olive: 'Olive',
  cyan: 'Cyan',
  coral: 'Coral',
  mint: 'Soft mint',
  blush: 'Soft blush',
  sand: 'Soft sand',
  lilac: 'Soft lilac',
};

export const DEFAULT_SHELL_THEME = 'mist';
export const SHELL_THEME_STORAGE_KEY = 'shell-theme';
const LEGACY_STORAGE_KEY = 'shell-theme-preview';

export function isValidShellTheme(id) {
  return ALL_SHELL_THEME_IDS.includes(id);
}

export function isSelectableShellTheme(id) {
  return SHELL_THEMES.some((t) => t.id === id);
}

export function getShellThemeLabel(id) {
  return SHELL_THEME_LABELS[id] || id;
}

export function getStoredShellTheme() {
  try {
    const saved = localStorage.getItem(SHELL_THEME_STORAGE_KEY)
      || localStorage.getItem(LEGACY_STORAGE_KEY);
    if (saved && isValidShellTheme(saved)) return saved;
  } catch {
    /* ignore */
  }
  return DEFAULT_SHELL_THEME;
}

export function setStoredShellTheme(id) {
  if (!isValidShellTheme(id)) return;
  try {
    localStorage.setItem(SHELL_THEME_STORAGE_KEY, id);
    localStorage.removeItem(LEGACY_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function applyShellTheme(id) {
  const theme = isValidShellTheme(id) ? id : DEFAULT_SHELL_THEME;
  const el = document.querySelector('.App');
  if (el) el.setAttribute('data-shell-theme', theme);
  return theme;
}
